module.exports = __webpack_public_path__ + "static/media/heart.20d59f6e.svg";